import { Text } from "@certn/cascadia-react";
import { ActionListControl } from "@certn/forms/src/controls/ActionListControl";
import { splitAndCapitalize } from "@certn/forms/src/controls/utils";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";

export function ProofOfIncomeControl(props: ArrayControlProps) {
  // Can do some sort of mapping which can customize what content gets returned below based on income_type.
  return (
    <ActionListControl
      {...props}
      renderTitle={(item) => {
        return (
          <>
            <Text style="global/heading-medium" color="text-weak">
              {item?.company_name
                ? item.company_name
                : splitAndCapitalize(item.income_type)}
            </Text>
          </>
        );
      }}
      renderSubtitle={(item) => {
        return (
          <>
            <Text style="global/body-secondary" color="text-weak">
              {[
                item?.income?.currency,
                item?.income?.amount,
                item?.income_description,
              ]
                .filter(Boolean)
                .join(" ")}
            </Text>
          </>
        );
      }}
    />
  );
}

export const ProofOfIncomeControlRenderer =
  withJsonFormsArrayControlProps(ProofOfIncomeControl);
